import { clsx } from 'clsx';

import { OrderDetailCard } from '../order-detail-card';
import { useOrderProductsByCorridor } from './useOrderProductsByCorridor';
import { SubstitutionFlowProductHOC } from 'features/order/substitution-flow';

export function OrderProductsByCorridor(props) {
  const { showAddValueButton = true, classes = {}, orderId } = props;

  const {
    sortedProducts,
    handleCheckDefectProduct,
    isDefectProductsChecked,
  } = useOrderProductsByCorridor({ orderId });

  return (
    <div className={clsx(classes?.root)}>
      {sortedProducts.map((product, index) => {
        return (
          <SubstitutionFlowProductHOC
            key={`p-${index}`}
            orderId={orderId}
            orderProductId={product.order_product_id}
          >
            <OrderDetailCard
              orderId={orderId}
              product={product}
              showAddValueButton={showAddValueButton}
              handleCheckDefectProduct={handleCheckDefectProduct}
              isDefectProductsChecked={isDefectProductsChecked}
            />
          </SubstitutionFlowProductHOC>
        );
      })}
    </div>
  );
}
